// Availability flags (birth certificate, parent ID, etc.) come back from the API in
// inconsistent shapes — boolean true/false, or strings 'true'/'false', '1'/'0'.
// Normalize them to a tri-state: true = available, false = not available,
// null = not yet answered.
//
// A naive truthy check is NOT safe here: the string '0' (and 'false') is truthy in
// JS, so `value ? available : notAvailable` would treat a "not available" flag as
// available. That mismatch is what causes an uploaded document to be typed against
// the wrong availability option.
export const normalizeAvailability = (value: unknown): boolean | null => {
    if (value === true || value === 'true' || value === '1' || value === 1) {
        return true;
    }

    if (value === false || value === 'false' || value === '0' || value === 0) {
        return false;
    }

    return null;
};